import {
  UNIVERSITY_EMAIL_NOT_VERIFIED_LABEL,
  UNIVERSITY_EMAIL_VERIFIED_LABEL,
} from './constants';

export const getUniversityLabel = (isEmailVerified?: boolean) =>
  isEmailVerified
    ? UNIVERSITY_EMAIL_VERIFIED_LABEL
    : UNIVERSITY_EMAIL_NOT_VERIFIED_LABEL;
